import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'TabTitle';

const classes = {
  title: `${PREFIX}-title`
};

const StyledTypography = styled(Typography)(({ theme }) => ({
  [`&.${classes.title}`]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1)
  }
}));

interface TabTitleProps {
  title: string;
}

const TabTitle = ({ title }: TabTitleProps) => {
  return (
    <StyledTypography className={classes.title} variant="h5" noWrap>
      {title}
    </StyledTypography>
  );
};

export default TabTitle;
